import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  usePagination,
  useTable,
  useSortBy,
  useGlobalFilter,
  useAsyncDebounce,
} from 'react-table'
import { jwtDecode } from 'jwt-decode'
import { getAllUsers } from '../reduxLogic/reducers/auth/getAllUsersSlice'
import { searchMobileUser } from '../reduxLogic/reducers/auth/searchMobileUser'
import { getAllProjects } from '../reduxLogic/reducers/projects/getAllProjectSlice'
import editIcon from '../assets/images/edit.png'
import deleteIcon from '../assets/images/delete.png'
import { changeDateTimeFormat } from '../shared/Helper'
import * as Styles from './style'
import axios from 'axios'
import Select from 'react-select'
import EditUserForm from '../Farmers/components/UserForm/EditUserForm'
import UserForm from '../Farmers/components/UserForm/UserForm'
import Cookies from 'universal-cookie'
import { act } from 'react'
import Header from 'antd/lib/calendar/Header'
const cookies = new Cookies()

const options = [
  { value: 'super_admin', label: 'Super Admin' },
  { value: 'beekind_app_admin', label: 'Beekind App Admin' },
  { value: 'field_view_app_admin', label: 'Field View App Admin' },
  { value: 'bee_mitra', label: 'Bee Mitra' },
  { value: 'community_leader', label: 'Community Leader' },
  { value: 'beekeeper', label: 'Beekeeper' },
  { value: 'trainee_beekeeper', label: 'Trainee Beekeeper' },
  { value: 'farmer', label: 'Farmer' },
  { value: 'expert', label: 'Expert' },
  { value: 'funder', label: 'Funder' },
]

// How many rows are rendered at a time (see the lazy rendering block in UsersTable).
const LAZY_ROW_BATCH = 50

const roleFilterOptions = [
  { value: '', label: 'All' },
  ...options, // Reuse the same roles from the previous options array
]



const EmployeeIdCell = ({ row, onSave }) => {
  const userInfo = row?.original?.userInfo || row?.original || {}
  const userId = userInfo._id
  const initialEmpId = userInfo.employee_id || userInfo.employeeId || userInfo.employeeCode || ''

  const [isEditing, setIsEditing] = useState(false)
  const [empIdVal, setEmpIdVal] = useState(initialEmpId)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    setEmpIdVal(initialEmpId)
  }, [initialEmpId])

  const handleSave = async () => {
    setSaving(true)
    try {
      await onSave(userId, empIdVal)
      setIsEditing(false)
    } catch (err) {
      console.error('Failed to update employee_id:', err)
    } finally {
      setSaving(false)
    }
  }

  if (isEditing) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <input
          type="text"
          value={empIdVal}
          onChange={e => setEmpIdVal(e.target.value)}
          placeholder="e.g. BW0001"
          style={{
            width: '90px',
            padding: '3px 6px',
            fontSize: '12px',
            borderRadius: '4px',
            border: '1px solid #3182ce',
            outline: 'none',
            fontWeight: 600,
          }}
          autoFocus
          onKeyDown={e => {
            if (e.key === 'Enter') handleSave()
            if (e.key === 'Escape') setIsEditing(false)
          }}
        />
        <button
          onClick={handleSave}
          disabled={saving}
          title="Save Employee ID"
          style={{
            background: '#38a169',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '3px 7px',
            fontSize: '12px',
            cursor: 'pointer',
          }}
        >
          {saving ? '...' : '✓'}
        </button>
        <button
          onClick={() => {
            setEmpIdVal(initialEmpId)
            setIsEditing(false)
          }}
          title="Cancel"
          style={{
            background: '#e53e3e',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '3px 7px',
            fontSize: '12px',
            cursor: 'pointer',
          }}
        >
          ✕
        </button>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
      {initialEmpId ? (
        <span
          style={{
            fontWeight: 700,
            color: '#2b6cb0',
            backgroundColor: '#ebf8ff',
            padding: '3px 8px',
            borderRadius: '4px',
            border: '1px solid #bee3f8',
            fontSize: '12px',
            letterSpacing: '0.02em',
            fontFamily: 'monospace',
          }}
        >
          {initialEmpId}
        </span>
      ) : (
        <span style={{ color: '#a0aec0', fontSize: '12px', fontStyle: 'italic' }}>
          —
        </span>
      )}
      <button
        onClick={() => setIsEditing(true)}
        title="Edit Employee ID"
        style={{
          background: 'none',
          border: 'none',
          color: '#718096',
          cursor: 'pointer',
          padding: '2px',
          fontSize: '12px',
        }}
      >
        <i className="fa fa-pencil" aria-hidden="true"></i>
      </button>
    </div>
  )
}

const UsersTable = () => {
  const dispatch = useDispatch()
  const { token } = '' //useSelector((state) => state.auth || {});
  const currentToken = cookies.get('access_token')
  const userData = cookies.get('userData')
  const [mobileNumber, setMobileNumber] = useState('')
  const [filterByRole, setFilterByRole] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [openEditModal, setOpenEditModal] = useState(false)
  const [userToEdit, setUserToEdit] = useState('')

  useEffect(() => {
    dispatch(getAllUsers())
    dispatch(getAllProjects())
  }, [dispatch, token])

  const handleUpdateEmployeeId = async (userId, newEmpId) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_HUMBLEBEE_API_URL}/users/update`,
        {
          userInfo: {
            _id: userId,
            employee_id: newEmpId,
          },
        },
        {
          headers: {
            authorization: `Bearer ${currentToken}`,
            source: 'humblebee_admin',
          },
        }
      )
      dispatch(getAllUsers())
    } catch (error) {
      console.error('Error updating employee ID:', error)
      alert('Failed to update Employee ID')
      throw error
    }
  }

  let role
  if (currentToken?.length > 0) {
    const decoded = jwtDecode(currentToken)
    role = decoded?.role
  }
  const [searchInput, setSearchInput] = useState('') // Renamed for clarity

  const { allUsers } = useSelector(state => state.allUsers)
  const { mobileUser } = useSelector(state => state.mobileUser)

  const { projectData } = useSelector(state => state.allProjects)

  const columns = useMemo(
    () => [
      {
        Header: 'DP',
        maxWidth: 60,
        minWidth: 60,
        width: 60,
        Cell: ({ row }) => {
          return row?.original?.userInfo?.profilePictureUrl ? (
            <img
              src={row?.original?.userInfo?.profilePictureUrl}
              alt="Profile"
              style={{ width: '50px', height: '50px', borderRadius: '50%' }}
            />
          ) : (
            <img
              src="https://media.istockphoto.com/id/1414774612/vector/bee-character.jpg?s=612x612&w=0&k=20&c=YBLQKadPoBfsSGGLBvkAt_3LqEytdHH3DVEE7dJUxqw="
              alt="Profile"
              style={{ width: '50px', height: '50px', borderRadius: '50%' }}
            />
          )
        },
      },
      {
        Header: 'Employee ID',
        maxWidth: 130,
        minWidth: 110,
        width: 120,
        accessor: 'userInfo.employee_id',
        Cell: ({ row }) => (
          <EmployeeIdCell row={row} onSave={handleUpdateEmployeeId} />
        ),
      },
      {
        Header: 'Name',
        maxWidth: 80,
        minWidth: 80,
        width: 80,
        accessor: 'userInfo.name',
      },
      {
        Header: 'Mobile',
        maxWidth: 100,
        minWidth: 100,
        width: 100,
        accessor: 'userInfo.mobileNumber',
      },
      {
        Header: 'Profile',
        maxWidth: 40,
        minWidth: 40,
        width: 40,
        Cell: ({ row }) => {
          return (
            <a
              target="_blank"
              referrerPolicy="no-referrer"
              href={`/user-profile/${row.original.userInfo._id}`}
            >
              <i
                className="fa fa-arrow-right"
                aria-hidden="true"
                style={{ color: 'black', fontSize: 'x-large' }}
              ></i>
            </a>
          )
        },
      },
      {
        Header: 'Roles',
        maxWidth: 250,
        minWidth: 250,
        width: 250,
        accessor: 'userInfo.userRoles',
      },
      {
        Header: 'Assigned Project',
        maxWidth: 200,
        minWidth: 150,
        width: 170,
        Cell: ({ row }) => {
          const u = row?.original?.userInfo || row?.original
          const rawProj =
            u?.projectId ||
            u?.adminMetaInfo?.projectId ||
            u?.userMetaInfo?.projectId ||
            (u?.fieldViewData &&
              u?.fieldViewData[0] &&
              u?.fieldViewData[0]?.project_id) ||
            (row?.original?.fieldViewData &&
              row?.original?.fieldViewData[0] &&
              row?.original?.fieldViewData[0]?.project_id) ||
            (u?.projects && u?.projects[0])
          const projId = typeof rawProj === 'object' ? rawProj?._id : rawProj

          if (!projId || projId === 'undefined' || projId === 'null') {
            return (
              <span style={{ color: '#a0aec0', fontSize: '12px' }}>
                Not Assigned
              </span>
            )
          }

          const matchedProj = (projectData || []).find(
            p => p._id && String(p._id) === String(projId)
          )
          const projName =
            matchedProj?.name || (typeof rawProj === 'object' ? rawProj?.name : null)

          if (!projName) {
            return (
              <span style={{ color: '#a0aec0', fontSize: '12px' }}>
                Not Assigned
              </span>
            )
          }

          return (
            <span
              style={{
                fontWeight: 600,
                color: '#2b6cb0',
                backgroundColor: '#ebf8ff',
                padding: '4px 8px',
                borderRadius: '4px',
                border: '1px solid #bee3f8',
                fontSize: '12px',
                display: 'inline-block',
              }}
            >
              📁 {projName}
            </span>
          )
        },
      },
      {
        Header: 'App Installed',
        maxWidth: 60,
        minWidth: 60,
        width: 60,
        Cell: ({ row }) => {
          if (row.original.userInfo.logged_in) {
            return <span style={{ color: 'green' }}>Yes</span>
          } else {
            return <span style={{ color: 'red' }}>No</span>
          }
        },
      },
      {
        Header: 'Added On',
        maxWidth: 80,
        minWidth: 80,
        width: 80,
        accessor: 'userInfo.addedAt',
      },
      {
        Header: 'Updated On',
        maxWidth: 80,
        minWidth: 80,
        width: 80,
        accessor: 'userInfo.updatedAt',
      },
      {
        Header: 'Edit',
        maxWidth: 80,
        minWidth: 80,
        width: 80,
      },
    ],
    [projectData]
  )
  // const data = useMemo(() => mobileUser?.length > 0 ? mobileUser : allUsers, [allUsers, mobileUser]);
  // const data = useMemo(() => {
  //   const sourceData = mobileUser?.length > 0 ? mobileUser : allUsers;
  //   console.log("mobileUser",mobileUser.length, sourceData);
  //   if (filterByRole.value) {
  //     return sourceData.filter((user) =>
  //       user.userInfo.userRoles.includes(filterByRole.value)
  //     );
  //   }
  //   return sourceData;
  // }, [allUsers, mobileUser, filterByRole]);

  const data = useMemo(() => {
    let sourceData = allUsers

    // Check if we have a fetched mobile user that matches the searchInput
    const isMobileSearch = searchInput && /^\d{10}$/.test(searchInput)
    if (isMobileSearch && mobileUser && !Array.isArray(mobileUser) && mobileUser.mobileNumber === searchInput) {
      sourceData = [{
        userInfo: mobileUser,
        progress: [],
        currentProgress: {}
      }]
    } else if (Array.isArray(mobileUser) && mobileUser.length > 0) {
      sourceData = mobileUser
    }

    // Filter by role if specified
    let filteredData = filterByRole.value
      ? sourceData.filter(user =>
          user?.userInfo?.userRoles?.includes(filterByRole?.value)
        )
      : sourceData

    // Filter by search input (matches name, mobileNumber, or employee_id)
    if (searchInput && !isMobileSearch) {
      const query = searchInput.toLowerCase().trim()
      filteredData = filteredData.filter(user => {
        const u = user?.userInfo || {}
        const name = String(u.name || '').toLowerCase()
        const mobile = String(u.mobileNumber || '')
        const empId = String(u.employee_id || u.employeeId || u.employeeCode || '').toLowerCase()
        return name.includes(query) || mobile.includes(query) || empId.includes(query)
      })
    }

    return filteredData
  }, [allUsers, mobileUser, filterByRole, searchInput])

  // console.log("data", data);
  // //if not data then return unable to fetch data
  // if (data.message === "Could not fetch users") {
  //   console.log("data.message", data.message);
  //   return <h3>Unable to fetch data</h3>;
  // }

  const tableInstance = useTable(
    {
      columns: columns,
      data: data,
      initialState: { pageSize: 1000 },
    },
    useSortBy,
    usePagination
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    pageCount,
    gotoPage,
    setPageSize,
    state,
  } = tableInstance
  const { pageIndex, pageSize } = state

  // Lazy rendering: a page can hold up to thousands of rows, but only the first
  // LAZY_ROW_BATCH are put on screen; the next batch is added as the user scrolls to
  // the bottom. The page size, page count and pagination controls are unchanged.
  const [visibleCount, setVisibleCount] = useState(LAZY_ROW_BATCH)
  const sentinelRef = useRef(null)
  const visibleRows = useMemo(() => page.slice(0, visibleCount), [page, visibleCount])
  const hasMoreRows = visibleCount < page.length

  // Back to the first batch when the user changes what is listed. A background
  // refresh of the data (e.g. after saving an Employee ID) keeps the scroll position.
  useEffect(() => {
    setVisibleCount(LAZY_ROW_BATCH)
  }, [pageIndex, pageSize, searchInput, filterByRole])

  useEffect(() => {
    const node = sentinelRef.current
    if (!hasMoreRows) return undefined
    if (typeof IntersectionObserver === 'undefined') {
      // Very old browser: show the whole page instead of leaving rows hidden.
      setVisibleCount(page.length)
      return undefined
    }
    if (!node) return undefined
    const observer = new IntersectionObserver(
      entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          setVisibleCount(count => count + LAZY_ROW_BATCH)
        }
      },
      { rootMargin: '400px 0px' }
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [hasMoreRows, visibleCount, page.length])

  const handlePatchRequestChangeRole = async (_id, newRole, action) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_APP_USER_URL}/user/update-user-role`,
        {
          userId: _id,
          action: action,
          userRole: newRole,
        },
        {
          headers: {
            authorization: `Bearer ${currentToken}`,
            source: 'humblebee_admin',
          },
        }
      )
      dispatch(getAllUsers())
      if (mobileNumber?.length === 10) {
        dispatch(searchMobileUser(mobileNumber))
      }
      alert(`Role ${action === 'add' ? 'added' : 'removed'} successfully`)
    } catch (error) {
      console.log('There was some error while changing role => ', error)
    }
  }

  const handleRoleChange = (_id, event) => {
    const selectedRoles = event.map(option => option.value)
    const existingRoles = data.find(user => user.userInfo._id === _id).userInfo
      .userRoles

    // Detect if a role is being added or removed
    let action = ''
    let changedRole = ''

    if (selectedRoles.length > existingRoles.length) {
      // Role added
      action = 'add'
      changedRole = selectedRoles.find(role => !existingRoles.includes(role))
    } else {
      // Role removed
      action = 'remove'
      changedRole = existingRoles.find(role => !selectedRoles.includes(role))
    }

    const confirmChange = window.confirm(
      `Are you sure you want to edit the role?\n\nDetails:\nName: ${
        data.find(user => user.userInfo._id === _id).userInfo.name
      }\nMobile: ${
        data.find(user => user.userInfo._id === _id).userInfo.mobileNumber
      }\nRole: ${changedRole}`
    )

    if (confirmChange) {
      handlePatchRequestChangeRole(_id, changedRole, action)
    } else {
      alert('Role change cancelled')
    }
  }
  // const handleMobileSearch = (mobileNumber) => {
  //   setMobileNumber(mobileNumber);
  //   if (mobileNumber?.length === 10) {
  //     dispatch(searchMobileUser(mobileNumber));
  //   } else if (mobileNumber?.length === 0) {
  //     dispatch(getAllUsers());
  //     dispatch(searchMobileUser(mobileNumber));
  //   }
  // };

  const handleMobileSearch = value => {
    setSearchInput(value) // Update searchInput state
    if (value?.length === 10 && /^\d+$/.test(value)) {
      dispatch(searchMobileUser(value))
    }
  }

  const handleModalToggle = () => {
    setOpenModal(prev => !prev)
  }

  const handleEditModalToggle = (e) => {
    console.log('handleEditModalToggle called', e)
    const userInfo = e?.userInfo || e || {};
    const fullUser = {
      ...userInfo,
      adminMetaInfo: e?.adminMetaInfo || userInfo?.adminMetaInfo,
      userMetaInfo: e?.userMetaInfo || userInfo?.userMetaInfo,
      projectId: e?.projectId || userInfo?.projectId || e?.adminMetaInfo?.projectId || e?.userMetaInfo?.projectId,
      projects: e?.projects || userInfo?.projects,
      hasAccessToProjects: e?.hasAccessToProjects || userInfo?.hasAccessToProjects,
    }
    setUserToEdit(fullUser)
    setOpenEditModal(prev => !prev)
  }


  const handleOpenEditModal = (_id, user) => {
    return
  }

  return (
    <Styles.UserBox>
      <div style={{ height: '10vh' }}></div>
      <Styles.TableContainer>
        <Styles.SearchContainer>
          <Styles.SearchInput
            type="text"
            placeholder="Search by name / mobile / Employee ID"
            onChange={e => handleMobileSearch(e.target.value)}
          />
          <Select
            options={roleFilterOptions}
            value={filterByRole}
            onChange={selectedOption =>
              setFilterByRole(selectedOption || { value: '', label: 'All' })
            }
            placeholder="Filter by role"
            isClearable
            styles={{
              container: provided => ({
                ...provided,
                marginLeft: '10px',
                width: '300px',
              }),
            }}
          />

          <p
            style={{
              fontWeight: 'bold',
              fontSize: '1rem',
            }}
          >
            Total Users Count: {data?.length}
          </p>
          <Styles.ModalButton
            onClick={handleModalToggle}
            style={{ marginLeft: 'auto', display: 'block' }}
          >
            Create User
          </Styles.ModalButton>

          {openModal ? (
            <UserForm openModal={openModal} setOpenModal={setOpenModal} userToEdit={userToEdit} />
          ) : null}
          {openEditModal ? (
            <EditUserForm
              openEditModal={openEditModal}
              setOpenEditModal={setOpenEditModal}
              user={userToEdit}
            />
          ) : null}
        </Styles.SearchContainer>
        {userData.userType.name !== 'Funder' && data ? (
          <Styles.Table {...getTableProps()}>
            <Styles.THead>
              {headerGroups.map(headerGroup => (
                <Styles.THeadRow {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(headerColumn => (
                    <Styles.TH
                      {...headerColumn.getHeaderProps({
                        style: {
                          minWidth: headerColumn.minWidth,
                          width: headerColumn.width,
                        },
                        // headerColumn.getSortByToggleProps()
                      })}
                    >
                      {headerColumn.render('Header')}
                      <span>
                        {headerColumn.isSorted
                          ? headerColumn.isSortedDesc
                            ? ' 🔼'
                            : ' 🔽'
                          : ''}
                      </span>
                    </Styles.TH>
                  ))}
                </Styles.THeadRow>
              ))}
            </Styles.THead>

            <Styles.TBody {...getTableBodyProps()}>
              {visibleRows.map(singleRow => {
                prepareRow(singleRow)

                return (
                  <Styles.TBodyRow {...singleRow.getRowProps()}>
                    {singleRow.cells.map((singleCell, index) => (
                      <Styles.TD key={index}>
                        <span>
                          {singleCell.column.id === 'userInfo.addedAt' ||
                          singleCell.column.id === 'userInfo.updatedAt' ? (
                            <span>
                              {singleCell?.value?.length > 0
                                ? changeDateTimeFormat(singleCell?.value)
                                : '-'}
                            </span>
                          ) : (
                            <>
                              <span>
                                {singleCell.column.id ===
                                'userInfo.userRoles' ? (
                                  <div
                                    style={{
                                      width: 'auto',
                                    }}
                                  >
                                    <Select
                                      isMulti={true}
                                      value={singleCell?.value?.map(role => {
                                        return options.find(
                                          option => option?.value === role
                                        )
                                      })}
                                      options={options}
                                      onChange={event =>
                                        handleRoleChange(
                                          singleCell?.row?.original?.userInfo
                                            ?._id,
                                          event
                                        )
                                      }
                                      styles={{
                                        // container: (provided) => ({
                                        //   width: "200px",
                                        // }),
                                        control: base => ({
                                          ...base,
                                          minHeight: '30px', // Control the dropdown height
                                        }),
                                        menu: base => ({
                                          ...base,
                                          zIndex: 9999, // Ensures dropdown appears above other elements
                                        }),
                                        menuPortal: base => ({
                                          ...base,
                                          zIndex: 9999, // Portal the dropdown so it doesn't get cut off
                                        }),
                                        option: base => ({
                                          ...base,
                                          cursor: 'pointer',
                                        }),
                                      }}
                                      menuPortalTarget={document.body} // Ensure dropdown appears outside table
                                    />
                                  </div>
                                ) : (
                                  <span>{singleCell.render('Cell')}</span>
                                )}
                              </span>
                              <span>
                                {singleCell.column.Header === 'Edit' ? (
                                  <Styles.ActionSpan>
                                    <button
                                      onClick={() =>
                                        handleEditModalToggle(
                                          singleRow?.original
                                        )
                                      }
                                    >
                                      <img src={editIcon} alt="Edit" />{' '}
                                    </button>
                                  </Styles.ActionSpan>
                                ) : null}
                              </span>
                            </>
                          )}
                        </span>
                      </Styles.TD>
                    ))}
                  </Styles.TBodyRow>
                )
              })}
            </Styles.TBody>
          </Styles.Table>
        ) : (
          <h3>There was some error displaying table</h3>
        )}
        {hasMoreRows && (
          <div
            ref={sentinelRef}
            style={{ textAlign: 'center', padding: '12px', fontSize: '13px', color: '#718096' }}
          >
            Showing {visibleRows.length} of {page.length} users on this page. Scroll to load more...
          </div>
        )}
      </Styles.TableContainer>

      <Styles.PaginationmainContainer style={{ marginTop: '20px', paddingTop: '10px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '15px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <span>
              <strong>
                Page {pageIndex + 1} of {pageOptions.length}
              </strong>
            </span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ fontSize: '13px', fontWeight: 600, color: '#555' }}>Show:</span>
              <select
                value={pageSize}
                onChange={e => setPageSize(Number(e.target.value))}
                style={{
                  padding: '4px 8px',
                  borderRadius: '6px',
                  border: '1px solid #ff8701',
                  fontSize: '13px',
                  fontWeight: 700,
                  color: '#ff8701',
                  background: '#fff',
                  cursor: 'pointer'
                }}
              >
                {[100, 500, 1000, 2000, 3000, 5000].map(size => (
                  <option key={size} value={size}>
                    {size} / page
                  </option>
                ))}
              </select>
            </div>
          </div>
          <Styles.PaginationDiv style={{ marginTop: 0 }}>
            <Styles.PaginationButton
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {'<<'}
            </Styles.PaginationButton>
            <Styles.PaginationButton
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              Previous
            </Styles.PaginationButton>

            <Styles.PaginationInputDiv>
              <input
                type="number"
                defaultValue={pageIndex + 1}
                onChange={e => {
                  let jumpToPageNumber = e.target.value
                    ? Number(e.target.value) - 1
                    : 0
                  gotoPage(jumpToPageNumber)
                }}
              />
            </Styles.PaginationInputDiv>

            <Styles.PaginationButton onClick={nextPage} disabled={!canNextPage}>
              Next
            </Styles.PaginationButton>
            <Styles.PaginationButton
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {'>>'}
            </Styles.PaginationButton>
          </Styles.PaginationDiv>
        </div>
      </Styles.PaginationmainContainer>
    </Styles.UserBox>
  )
}

export default UsersTable
